import React from 'react'
import { createRoot } from 'react-dom/client'
import * as mod from 'gatsby-plugin-image'

/**
 * Hydrates inline images in the document namespace.
 *
 * @param {string} namespace The namespace of the inline html element
 */
export function hydrateInlineWpImages(namespace) {
    const inlineWPimages = getInlineWpImages(namespace)
    inlineWPimages.forEach(image => {
        const gatsbyImageHydrationElement = getHydrationElement(image)

        if (
            image.dataset &&
            image.dataset.wpInlineImage &&
            gatsbyImageHydrationElement
        ) {
            const hydrationData = document.querySelector(
                `${createNamespaceSelector(
                    namespace,
                )} script[data-wp-inline-image-hydration="${
                    image.dataset.wpInlineImage
                }"]`,
            )

            if (hydrationData) {
                const imageProps = JSON.parse(hydrationData.innerHTML)

                const root = createRoot(gatsbyImageHydrationElement)
                root.render(React.createElement(mod.GatsbyImage, imageProps))
            }
        }
    })
}

/**
 * Gets all inline images in the document namespace.
 * @param {string} namespace The namespace of the inline html element
 * @returns {Array} An array of inline images
 */
function getInlineWpImages(namespace) {
    if (typeof window === 'undefined') return []
    return Array.from(
        document.querySelectorAll(
            `${createNamespaceSelector(namespace)} [data-wp-inline-image]`,
        ),
    )
}

/**
 * Creates a selector for the inline html element.
 *
 * @param {string} namespace The namespace of the inline html element
 * @returns {string} The selector for the inline html element
 */
function createNamespaceSelector(namespace) {
    return namespace ? `#${namespace}-inline-html` : `body`
}

/**
 * Gets the hydration element for the image (script tag)
 *
 * @param {DOMElement} image The image to get the hydration element for
 * @returns {DOMElement} The hydration element for the image
 */
function getHydrationElement(image) {
    const grandParentIsGatsbyImage =
        image?.parentNode?.parentNode?.classList?.contains(
            `gatsby-image-wrapper`,
        )

    const parentIsGatsbyImage =
        image?.parentNode?.classList?.contains(`gatsby-image-wrapper`)

    if (!grandParentIsGatsbyImage && !parentIsGatsbyImage) {
        return
    }

    return grandParentIsGatsbyImage
        ? image.parentNode.parentNode
        : image.parentNode
}
